import { createContext } from "react";

export const TableContext = createContext(null);
